export const LATIN_ONLY_NAME_REGEXP = /^[\d\s'\-.A-Za-z]*$/gu;
export const LATIN_ONLY_ADDRESS_REGEXP = /^[\d\s#%&(),./@A-Za-z-]*$/gu;
export const USERNAME_REGEXP = /[\w!#'.^~-]/gu;
export const BIO_REGEXP = /[^\w.\-\s]/gu;
export const SEARCH_QUERY_TRANSFORM_REGEXP = /[^\s\dA-Za-z-]/gu;
export const EMAIL_REGEXP = /^[^@\s]+@[^.\s]+\.\S+$/gu;
export const HTTPS_URL_REGEXP =
  /^https:\/\/(?:www\.)?[-\w@:%.+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b[-\w()@:%+.~#?&/=]*$/gu;
export const DIGITS_ONLY_REGEXP = /^[1-9]\d*$/u;
